<template>
    <div>
        <Wp_nav_bar title="我的总预估收入详情"></Wp_nav_bar>
        <Wp_order_count_detail_model></Wp_order_count_detail_model>
    </div>
</template>

<script>
    import Wp_order_count_detail_model from "./Wp_order_count_detail_model";
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    export default {
        name: "Wp_order_count_detail_page",
        components: {Wp_nav_bar, Wp_order_count_detail_model}
    }
</script>

<style scoped>

</style>